import { Box, HStack, VStack } from "@chakra-ui/react";
import CDS from "design-system";

interface Props {
  startLabel: string | null;
  dueLabel: string | null;
}

const START_MARKER_SIZE = "10px";
const DUE_MARKER_SIZE = "10px";

function StartMarker() {
  return (
    <Box
      w={START_MARKER_SIZE}
      h={START_MARKER_SIZE}
      borderRadius="full"
      border="1.5px solid"
      borderColor="blue.500"
      bg="white"
    />
  );
}

function DueMarker() {
  return (
    <Box
      w={DUE_MARKER_SIZE}
      h={DUE_MARKER_SIZE}
      borderRadius="full"
      bg="blue.600"
    />
  );
}

function MarkerLabel({ name, descriptor }: { name: string; descriptor: string }) {
  return (
    <VStack spacing={0} align="center">
      <CDS.Text10 fontWeight="medium" color="fg.default">
        {name}
      </CDS.Text10>
      <CDS.Text10 color="gray.500" textAlign="center">
        {descriptor}
      </CDS.Text10>
    </VStack>
  );
}

export default function HoverCardTimeline({ startLabel, dueLabel }: Props) {
  if (!startLabel && !dueLabel) return null;

  if (!startLabel || !dueLabel) {
    const isStart = Boolean(startLabel);
    return (
      <VStack spacing={1.5} align="center" w="100%">
        {isStart ? <StartMarker /> : <DueMarker />}
        <MarkerLabel
          name={isStart ? "Starts" : "Due"}
          descriptor={(isStart ? startLabel : dueLabel) as string}
        />
      </VStack>
    );
  }

  return (
    <Box w="100%">
      <HStack spacing={0} align="center" w="100%">
        <StartMarker />
        <Box flex={1} h="1px" bg="gray.200" />
        <DueMarker />
      </HStack>
      <HStack spacing={0} align="flex-start" w="100%" mt={1.5}>
        <Box flex={1} display="flex" justifyContent="flex-start">
          <MarkerLabel name="Starts" descriptor={startLabel} />
        </Box>
        <Box flex={1} display="flex" justifyContent="flex-end">
          <MarkerLabel name="Due" descriptor={dueLabel} />
        </Box>
      </HStack>
    </Box>
  );
}
